import React from 'react';

const Auth = React.lazy(() => import('@apps/Account/Auth'));
const ChangePassword = React.lazy(() => import('@apps/Account/ChangePassword'));
const Login = React.lazy(() => import('@apps/Account/Login'));
const Recovery = React.lazy(() => import('@apps/Account/Recovery'));
const Registration = React.lazy(() => import('@apps/Account/Registration'));
const StatYear = React.lazy(() => import('@apps/Account/StatYear'));
const ProfilePage = React.lazy(() => import('@apps/Account/Profile/ProfilePage'));
const OneUserPage = React.lazy(() => import('@apps/Users/pages/OneUserPage'));

const EmailConfirmPage = React.lazy(() => import('@apps/Users/pages/EmailConfirmPage'));
const SubscribeConfirmPage = React.lazy(() => import('@apps/Users/pages/SubscribeConfirmPage'));
const UsersPage = React.lazy(() => import('@apps/Users/pages/UsersPage'));

import { IPohodnikRouterItem } from '.';

const userRoutes: Array<IPohodnikRouterItem> = [
  {
    path: '/login',
    title: 'Авторизоваться',
    component: () => <Login />,
  },
  {
    path: '/reg',
    title: 'Зарегистрироваться',
    component: () => <Registration />,
  },
  {
    path: '/auth',
    component: () => <Auth />,
  },
  {
    path: '/recovery',
    title: 'Восстановление пароль',
    component: () => <Recovery />,
  },
  {
    path: '/changePassword/:code',
    component: ({
      match: {
        params: { code },
      },
    }) => <ChangePassword code={code} />,
    protected: false,
    title: 'Изменение пароля (подтверждение кода)',
  },
  {
    path: '/confirm-email/:code',
    component: ({
      match: {
        params: { code },
      },
    }) => <EmailConfirmPage code={code} />,
    protected: true,
    title: 'Подтверждение e-mail',
  },
  {
    path: '/confirm-subscribe/:code',
    component: ({
      match: {
        params: { code },
      },
    }) => <SubscribeConfirmPage code={code} />,
    protected: true,
    title: 'Подтверждение подписки',
  },
  {
    path: '/changePassword',
    component: () => <ChangePassword />,
    protected: true,
    title: 'Изменение пароля (подтверждение кода)',
  },
  {
    path: '/user/:id/stat/:year',
    component: ({
      match: {
        params: { id, year },
      },
    }) => <StatYear user={+id} year={+year} />,
    protected: true,
    title: 'Годовая статистика',
  },
  {
    path: '/user/:id',
    component: ({
      match: {
        params: { id },
      },
    }) => <OneUserPage id_user={+id} />,
    title: 'Страница походника',
  },
  {
    path: '/users',
    component: () => <UsersPage />,
    protected: true,
    title: 'Походники',
  },
  {
    path: '/profile',
    component: () => <ProfilePage />,
    protected: true,
    title: 'Профиль походника',
  },
];

export default userRoutes;
